export default __webpack_public_path__ + "static/scroll_phone_1-7938cdbb45b342ee4318ce8f35236a7d.png";